import { render } from "./SetApprovals.vue?vue&type=template&id=6c7cac90&scoped=true"
import script from "./SetApprovals.vue?vue&type=script&lang=js"
export * from "./SetApprovals.vue?vue&type=script&lang=js"

import "./SetApprovals.vue?vue&type=style&index=0&id=6c7cac90&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7cac90"]])

export default __exports__